<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center pb-4">
        <div class="col-lg-6 col-7">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 d-none d-md-inline-block">
          <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="form_laive" :class="{ 'validateClient' : isLoading}">
        <div class="box_loader">
          <div class="loader"></div>
        </div>
        <card
          class="no-border-card"
          body-classes="pb-1"
          footer-classes="pb-2"
        >
          <template v-slot:header>
            <div class="row">
              <div class="col-12 col-md-6">
                <h3 class="mb-0">Recomendaciones por Categoria</h3>
              </div>
            </div>
          </template>
          <div>
            <div class="row">
              <div class="col-12 col-md-10 mb-3">
                <div class="row">
                  <div class="col-12 col-md-3 ">
                    <template v-if="distribuidoraIdCurrent">
                      <div class="title_filter mr-2"><div>Distribuidora:</div>  <strong>{{distribuidoraNameCurrent}}</strong></div>
                    </template>
                    <template v-else>
                      <span class="title_filter mr-2">Distribuidoras:  </span>
                      <select v-model="dataReport.iddistribuidora" class="form-control" id="distributor_select" name="distributor_select" @change="changeListbyDistribuidora">
                        <option value="0">Todos</option>
                        <option
                          v-for="item in distribuidoras"
                          :value="item.idDistribuidora"
                          :key="item.idDistribuidora"
                          >
                          {{ item.razonSocial }}
                        </option>
                      </select>
                    </template>
                  </div>
                  <div class="col-12 col-md-3">
                    <template v-if="mesaCurrent">
                      <div class="title_filter mr-2"><div>Mesa:</div>  <strong>{{mesaCurrent}}</strong></div>
                    </template>
                    <template v-else>
                      <span class="title_filter mr-2">Mesa:  </span>
                      <select v-model="dataReport.codigomesa" class="form-control" id="mesa_select" name="mesa_select" @change="changeListbyMesa">
                        <option value="">Todos</option>
                        <option
                            v-for="item in mesas"
                            :value="item.codigoDato"
                            :key="item.codigoDato"
                            >
                            {{ item.nombre }}
                          </option>
                      </select>
                    </template>
                  </div>
                  <div class="col-12 col-md-3">
                    <span class="title_filter mr-2">Vendedor:  </span>
                    <select v-model="dataReport.codigovendedor" class="form-control" id="vendedor_select" name="vendedor_select" @change="changeListbyVendedor">
                      <option value="">Todos</option>
                      <option
                        v-for="item in vendedores"
                        :value="item.codigoVendedor"
                        :key="item.codigoVendedor+item.distribuidora"
                        >
                        {{ item.nombre }} {{ item.apellidos }}
                      </option>
                    </select>
                  </div>
                  <div class="col-12 col-md-3">
                    <span class="title_filter mr-2">Fechas: </span>
                    <select @change="changeListFecha" v-model="dataReport.periodo" class="form-control" id="fecha_select" name="fecha_select">
                      <option value="">Todas</option>
                      <option
                        v-for="item in fechas"
                        :value="item.codigoDato"
                        :key="item.codigoDato"
                        >
                        {{ item.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <!-- Real Table -->
            <p class="form-control-label badge badge-info badge-laive" @click="closeTag" v-if="dataReport.changeCat && dataReport.changeFam === false">
              Categoria: {{dataReport.nameCategoria}}
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </p>
            <p class="form-control-label badge badge-info badge-laive" @click="closeTag" v-if="dataReport.changeFam">
              Familia: {{dataReport.nameFamilia}}
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </p>
            <el-table
              :data="queriedData"
              row-key="idReportPromo"
              empty-text="Debe seleccionar una Distibuidora"
              header-row-class-name="thead-light"
              style="width: 100%"
            >
              <el-table-column prop="categoria" label="Categoria" width="165" fixed v-if="dataReport.changeCat === false"/>
              <el-table-column prop="familia" label="Familia" width="150" fixed v-if="dataReport.changeCat && dataReport.changeFam === false"/>
              <el-table-column prop="producto" label="Producto" width="300" fixed v-if="dataReport.changeFam"/>
              <el-table-column label="Venta pedidos" prop="montoVentas" width="170">
                <template v-slot="{ row }">
                  S/{{ formatNumber(row.montoVentas) }}
                </template>
              </el-table-column>
              <el-table-column label="Ventas con Reco" prop="montoVentasRecomendacion" width="185">
                <template v-slot="{ row }">
                  S/{{ formatNumber(row.montoVentasRecomendacion) }}
                </template>
              </el-table-column>
              <el-table-column label="S/ reco" prop="montoRecomendacion" width="120">
                <template v-slot="{ row }">
                  S/{{ formatNumber(row.montoRecomendacion) }}
                </template>
              </el-table-column>
              <el-table-column label="% reco" prop="porcentajeRecomendacion" width="120">
                <template v-slot="{ row }">
                  {{ formatNumber(row.porcentajeRecomendacion) }}%
                </template>
              </el-table-column>
              <el-table-column label="% Reco vs Ventas" prop="porcentajeRecomendacionVentas" width="190">
                <template v-slot="{ row }">
                  {{ formatNumber(row.porcentajeRecomendacionVentas) }}%
                </template>
              </el-table-column>
              <el-table-column label="# Pedidos" prop="numeroPedidos" width="140"/>
              <el-table-column label="# Pedidos con Reco" prop="numeroPedidosRecomendacion" width="200"/>
              <el-table-column label="% Pedidos con Reco" prop="porcentajePedidosRecomendacion" width="200">
                <template v-slot="{ row }">
                  {{ formatNumber(row.porcentajePedidosRecomendacion) }}%
                </template>
              </el-table-column>
              <el-table-column label="Ticket Reco" prop="ticketPromedioRecomendacion" width="150"/>
              <el-table-column width="120" align="right" fixed="right" v-if="dataReport.changeFam == false">
                <template v-slot:default="props">
                  <base-button type="info" class="detail" size="sm" role="button" @click="openDetail(props.row)">Detalle</base-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <template v-slot:footer>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
              <div class="">
                <p class="card-category d-none">
                  Mostrando {{ from + 1 }} a {{ to }} de {{ total }} Depositos
                </p>
              </div>
            </div>
          </template>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import {
  ElTable,
  ElTableColumn,
  ElSelect,
  ElOption,
  ElInput,
} from "element-plus";
import axios from "axios";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import TabPane from "@/components/Tabs/TabPane";
import BasePagination from "@/components/BasePagination";
import {mapGetters, mapActions} from 'vuex';
import DashboardNavbar from "./../Layout/DashboardNavbar";
export default {
  components: {
    DashboardNavbar,
    BasePagination,
    RouteBreadCrumb,
    TabPane,
    [ElSelect.name]: ElSelect,
    [ElOption.name]: ElOption,
    [ElTable.name]: ElTable,
    [ElInput.name]: ElInput,
    [ElTableColumn.name]: ElTableColumn,
  },
  computed: {
    pagedData() {
      this.getDistributor
      this.getVendedor
      this.getMesas
      this.getFechas
      this.getDataRecomendadoCategoria
      return this.tableData
    },
    queriedData() {
      if (!this.searchQuery) {
        return this.pagedData;
      }
      let result = this.tableData.filter((row) => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString().toLowerCase();
          if (rowValue.includes && rowValue.includes(this.searchQuery.toLowerCase())) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.pagination.total;
    },
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
    }),
    async getDistributor(){
      try{
        let result = await this.getDistributorList();
        this.distribuidoras = result.data ? result.data.filter((item) => { return item.estado == "1" }) : [];
        if(this.distribuidoraIdCurrent){
          let dataDistibuitorCurrent =  this.distribuidoras.filter((item)=>{return item.idDistribuidora == this.distribuidoraIdCurrent})
          this.distribuidoraNameCurrent = dataDistibuitorCurrent[0].razonSocial
        }
      }
      catch(ex){ex}
    },
    async getMesas(){
      if(this.distribuidoraIdCurrent){
        let result = await this.getMesaByDistribuidora(this.dataReport);
        this.mesas = result.data ? result.data : [];
      }else{
        console.info("no hay id de distribuidora para mesas")
      }
    },
    async getVendedor(){
      if (this.supervisorIdCurrent) {
        this.dataReport.codigomesa = this.mesaCurrent
        let result = await this.getVendedorByMesa(this.dataReport);
        this.vendedores = result.data ? result.data : [];
      }else{
        console.info("no hay id de supervisor")
      }
    },
    async getFechas(){
      const $this = this;
      const token = localStorage.getItem("token")
      const config = {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      };
      const urlApiFechas = process.env.VUE_APP_API_URL+"/maestro/lista/listafecha"
      await axios.get(urlApiFechas,config)
      .then(function (response){
        return $this.fechas = response.data
      })
    },
    getDataRecomendadoCategoria() {
      const $this = this
      const token = localStorage.getItem("token")
      const config = {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      };
      if(this.dataReport.year && this.dataReport.month && this.initload){
        if(this.distribuidoraIdCurrent){
          this.dataReport.iddistribuidora = Number(this.distribuidoraIdCurrent)
        }
        axios.post(process.env.VUE_APP_API_URL+"/producto/recomendado/reporte/categoria",this.dataReport,config)
        .then(function (response){
          $this.emptyText = "No se encontraron resultados"
          $this.pagination.perPage = response.data.length
          $this.initload = false
          $this.isLoading = false
          return $this.tableData = response.data
        })
      }
    },
  },
  methods:{
    ...mapActions({
        getDistributorList: 'distribuidora/getList',
        getMesaByDistribuidora: "mesa/getListByDistribuidora",
        getVendedorByMesa:'vendedor/getListByMesa',
    }),
    changeListbyDistribuidora(evn){
      const $this = this
      const token = localStorage.getItem("token")
      const config = {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      };
      const targetElm = Number(this.dataReport.iddistribuidora)
      this.isLoading = true
      this.dataReport.codigomesa = (this.mesaCurrent) ? this.mesaCurrent : ""
      // this.dataReport.nameDistribuidora = this.distribuidoras.filter((item)=>{return item.idDistribuidora == targetElm})[0].razonSocial
      this.dataReport.page = 1
      this.getMesaByDistribuidora(this.dataReport).then((result) => {
        $this.mesas = result.data ? result.data : [];
      });

      axios.post(process.env.VUE_APP_API_URL+"/producto/recomendado/reporte/categoria",this.dataReport,config)
      .then(function (response){
        console.log(response.data, " ====lista de reporte");
        $this.emptyText = "No se encontraron resultados"
        $this.initload = false
        $this.isLoading = false
        return $this.tableData = response.data
      }).catch(errors => {
        $this.isLoading = false
      })
    },
    changeListbyMesa(env){
      const $this = this
      const token = localStorage.getItem("token")
      const config = {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      };
      this.isLoading = true
      const targetElm = document.querySelector("#mesa_select")
      if(targetElm.value.length){
        this.getVendedorByMesa(this.dataReport).then((result) => {
          $this.vendedores = result.data ? result.data : [];
        });
      }else{
        this.vendedores = ""
      }
      this.dataReport.codigovendedor = ""
      this.dataReport.page = 1
      axios.post(process.env.VUE_APP_API_URL+"/producto/recomendado/reporte/categoria",this.dataReport,config)
      .then(function (response){
        $this.emptyText = "No se encontraron resultados"
        $this.initload = false
        $this.isLoading = false
        return $this.tableData = response.data
      }).catch(errors => {
        $this.isLoading = false
      })
    },
    changeListbyVendedor(){
      const $this = this
      const token = localStorage.getItem("token")
      const config = {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      };
      this.isLoading = true
      this.dataReport.page = 1
      axios.post(process.env.VUE_APP_API_URL+"/producto/recomendado/reporte/categoria",this.dataReport,config)
      .then(function (response){
        $this.emptyText = "No se encontraron resultados"
        $this.initload = false
        $this.isLoading = false
        return $this.tableData = response.data
      }).catch(errors => {
        $this.isLoading = false
      })
    },
    changeListFecha(){
     const $this = this
      const token = localStorage.getItem("token")
      const config = {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      };
      this.isLoading = true
      this.dataReport.page = 1
      axios.post(process.env.VUE_APP_API_URL+"/producto/recomendado/reporte/categoria",this.dataReport,config)
      .then(function (response){
        $this.emptyText = "No se encontraron resultados"
        $this.initload = false
        $this.isLoading = false
        return $this.tableData = response.data
      }).catch(errors => {
        $this.isLoading = false
      })
    },
    changePaginate(evn){
      const $this = this
      const listPaginator = document.querySelectorAll("ul.pagination .page-item")
      let elm = evn.target;
      let sendAjax = false;
      let parentEl = elm.parentNode
      if(elm.classList.contains("prev-page")){
        if(!elm.classList.contains("disabled")){
          let linkActivePrev = document.querySelectorAll("ul.pagination .page-item.active")
          linkActivePrev[0].classList.remove("active")
          linkActivePrev[0].previousSibling.classList.add("active")
          sendAjax = true
        }
      }else if(elm.classList.contains("next-page")){
      }else{
        if(elm.getAttribute("aria-label") == "Previous"){
          let linkActivePrev = document.querySelectorAll("ul.pagination .page-item.active")
          linkActivePrev[0].classList.remove("active")
          linkActivePrev[0].previousSibling.classList.add("active")
          sendAjax = true
        }else if(elm.getAttribute("aria-label") == "Next"){
          let linkActiveNext = document.querySelectorAll("ul.pagination .page-item.active")
            linkActiveNext[0].classList.remove("active")
            linkActiveNext[0].nextSibling.classList.add("active")
            sendAjax = true
        }else{
          if(!parentEl.classList.contains("active")){
            listPaginator.forEach(item => {
              item.classList.remove("active")
            });
            parentEl.classList.add("active")
            sendAjax = true
          }
        }
      }
      const token = localStorage.getItem("token")
      const config = {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      };
      if(sendAjax){
        this.isLoading = true
        axios.post(process.env.VUE_APP_API_URL+"/producto/recomendado/lista",this.dataReport,config)
        .then(function (response){
          console.log(response.data.data)
          sendAjax = false
          $this.dataReport.page = response.data.page
          $this.pagination.perPage = response.data.data.length
          $this.pagination.total = response.data.totalPage
          $this.isLoading = false
          return $this.tableData = response.data.data
        })
      }
    },
    openDetail(row){
      const data = row
      this.isLoading = true
      if (typeof data.categoria != 'undefined') {
        // console.log(data, " categoria")
        this.dataReport.codigoCategoria = data.codigoCategoria
        this.dataReport.nameCategoria = data.categoria
        this.dataReport.tagActive = "categoria"
        this.dataReport.changeCat = true
      }
      if (typeof data.familia != 'undefined') {
        console.log(data, " familia")
        this.dataReport.codigoFamilia = data.codigoFamilia
        this.dataReport.nameFamilia = data.familia
        this.dataReport.tagActive = "familia"
        this.dataReport.changeFam = true
      }
      this.changeListbyDistribuidora()
    },
    closeTag(){
      this.isLoading = true
      console.log(this.dataReport.tagActive)
      if(this.dataReport.tagActive == "categoria"){
        this.dataReport.codigoCategoria = ""
        this.dataReport.changeCat = false
      }
      if(this.dataReport.tagActive == "familia"){
        this.dataReport.codigoFamilia = ""
        this.dataReport.changeFam = false
        this.dataReport.tagActive = "categoria"
      }
      this.changeListbyDistribuidora()
    },
    formatNumber(num) {
      var nf = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
      return nf.format(num)
		  // return new Intl.NumberFormat("en-IN").format(num)
	  },
    resetPagination(value){
      const paginate = document.querySelectorAll(".page-item.number")
      let index = value - 1
      paginate.forEach(item => {
        if(item.classList.contains("active")){
          item.classList.remove("active")
        }
      });
      paginate[index].classList.add("active");
    }
  },
  mounted() {
    if(this.user.rol == 3){
      this.distribuidoraIdCurrent = this.user.idDistribuidora
    }
    if(this.user.rol == 4){
      this.supervisorIdCurrent = this.user.codigo
      this.supervisorNameCurrent = this.user.nombre
      this.distribuidoraIdCurrent = this.user.idDistribuidora
      this.mesaCurrent = this.user.mesa
    }
    let currentDate = new Date();
    let month = currentDate.getMonth() + 1
    this.dataReport.year = currentDate.getFullYear()
    this.dataReport.month = month
  },
  data() {
    return {
      initload: true,
      isLoading: true,
      distribuidoraIdCurrent: null,
      distribuidoraNameCurrent: null,
      supervisorIdCurrent: null,
      supervisorNameCurrent: null,
      mesaCurrent : null,
      emptyText: "No se encontraron resultados",
      pagination: {
        perPage: 2,
        currentPage: 1,
        newcurrentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 1,
      },
      modal:{
        open: false,
        title: "",
        data: []
      },
      dataReport:{
        iddistribuidora: 0,       // Obligatorio
        nameDistribuidora: "",
        codigovendedor: "",       // Obligatorio
        periodo: "1",
        page : 1,
        tipo: "mesas",
        codigomesa: "",
        nameCategoria: "",
        codigoCategoria: "",
        nameFamilia: "",
        codigoFamilia: "",
        changeCat: false,
        changeFam: false,
        tagActive: "",
      },
      distribuidoras:[],
      supervisores:[],
      vendedores:[],
      mesas:[],
      fechas: [],
      searchQuery: "",
      propsToSearch: ["cliente", "codigo"],
      tableColumns: [
        {
          prop: "distribuidora",
          label: "distribuidora",
          width: 150,
          fixed: true
        },
        {
          prop: "montoVentas",
          label: "Venta pedidos",
          width: 170,
        },
        {
          prop: "montoVentasRecomendacion",
          label: "Pedido con Reco",
          width: 180,
        },
        {
          prop: "montoVentasRecomendacion",
          label: "S/ reco",
          width: 120,
        },
        {
          prop: "porcentajeRecomendacion",
          label: "% reco",
          width: 120,
        },
        {
          prop: "porcentajeRecomendacionVentas",
          label: "% Reco vs Ventas",
          width: 190,
        },
        {
          prop: "numeroPedidos",
          label: "# Pedidos",
          width: 140,
        },
        {
          prop: "numeroPedidosRecomendacion",
          label: "# Pedidos con Reco",
          width: 200,
        },
        {
          prop: "porcentajeRecomendacionVentas",
          label: "% Pedidos con Reco",
          width: 200,
        },
        {
          prop: "ticketPromedioRecomendacion",
          label: "Ticket Reco",
          width: 150,
        },
      ],
      tableData: [],
      fuseSearch: null,
      searchedData: [],
      expands: [],
    };
  },
};
</script>
